// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelAddress } from './medicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPatient {
    'firstName'?: string | null;
    'middleName'?: string | null;
    'lastName'?: string | null;
    'suffix'?: string | null;
    'memberId'?: string | null;
    'familyUnitNumber'?: string | null;
    'subscriberRelationship'?: string | null;
    'subscriberRelationshipCode'?: string | null;
    'gender'?: string | null;
    'birthDate'?: string | null;
    'deathDate'?: string | null;
    'address'?: MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelAddress | null;
    'isDependent'?: boolean | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPatient>> = [
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "middleName",
            "baseName": "middleName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "suffix",
            "baseName": "suffix",
            "type":     "string"
        },
        {
            "name":     "memberId",
            "baseName": "memberId",
            "type":     "string"
        },
        {
            "name":     "familyUnitNumber",
            "baseName": "familyUnitNumber",
            "type":     "string"
        },
        {
            "name":     "subscriberRelationship",
            "baseName": "subscriberRelationship",
            "type":     "string"
        },
        {
            "name":     "subscriberRelationshipCode",
            "baseName": "subscriberRelationshipCode",
            "type":     "string"
        },
        {
            "name":     "gender",
            "baseName": "gender",
            "type":     "string"
        },
        {
            "name":     "birthDate",
            "baseName": "birthDate",
            "type":     "string"
        },
        {
            "name":     "deathDate",
            "baseName": "deathDate",
            "type":     "string"
        },
        {
            "name":     "address",
            "baseName": "address",
            "type":     "MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelAddress"
        },
        {
            "name":     "isDependent",
            "baseName": "isDependent",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalCardFinderResultSearchMedicalCardFinderResultSearchResponseDetailModelPatient.attributeTypeMap;
    }
}
